import CustomButton from "@/components/ui/customButton/customButton.vue";

export default {
    name: "ErrorView",
    components: {
        CustomButton,
    },
};
